<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style2', { sticky: isSticky }]">
      <div class="container">
        <div class="header-top">
          <TopHeader />
        </div>
      </div>
      <MainNavbar />
    </div>
    <MainBanner />
    <HowWeWork />
    <GetToKnowUs />
    <BestServices />
    <CallToAction />
    <OurDoctors />
    <OurDepartment />
    <OurTestimonials />
    <GalleryExhibition />
    <OurPricing />
    <TouchWithUs />
    <OurPartner />
    <LatestNews />
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layouts/TopHeader.vue";
import MainNavbar from "../Layouts/MainNavbar.vue";
import MainBanner from "../HomeTwo/MainBanner.vue";
import HowWeWork from "../HomeTwo/HowWeWork.vue";
import GetToKnowUs from "../HomeTwo/GetToKnowUs.vue";
import BestServices from "../HomeTwo/BestServices.vue";
import CallToAction from "../HomeTwo/CallToAction.vue";
import OurDoctors from "../HomeTwo/OurDoctors.vue";
import OurDepartment from "../HomeTwo/OurDepartment.vue";
import OurTestimonials from "../HomeTwo/OurTestimonials.vue";
import GalleryExhibition from "../HomeTwo/GalleryExhibition.vue";
import OurPricing from "../HomeTwo/OurPricing.vue";
import TouchWithUs from "../HomeTwo/TouchWithUs.vue";
import OurPartner from "../HomeTwo/OurPartner.vue";
import LatestNews from "../HomeTwo/LatestNews.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeTwoPage",
  components: {
    TopHeader,
    MainNavbar,
    MainBanner,
    HowWeWork,
    GetToKnowUs,
    BestServices,
    CallToAction,
    OurDoctors,
    OurDepartment,
    OurTestimonials,
    GalleryExhibition,
    OurPricing,
    TouchWithUs,
    OurPartner,
    LatestNews,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>